var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import ReactLoading from 'react-loading';
import { ComponentClass } from 'conversional-theme';
import { JourneysSelectors, useAppSelector } from 'conversional-journey';
import LoadingMessage from './LoadingMessage';
import { getStyles } from './Loading.styles';
import classNames from "classnames";
var classes = getStyles();
var DEFAULT_LOADING_TRANSLATION_KEY = 'common.loading';
function Loading(props) {
    var styles = props.styles, message = props.message, messageColor = props.messageColor, _a = props.color, color = _a === void 0 ? "#A8A8A8" : _a, _b = props.size, size = _b === void 0 ? 64 : _b;
    // @ts-ignore
    var defaultLoadingMessage = useAppSelector(function (state) { return JourneysSelectors.selectTranslationKey(state, DEFAULT_LOADING_TRANSLATION_KEY); });
    return (_jsxs("div", { className: classNames(ComponentClass(styles), classes.journeyLoader), children: [message && _jsx(LoadingMessage, { message: message || defaultLoadingMessage, color: messageColor }), _jsx(ReactLoading, { height: size, width: size, type: "bars", color: color, delay: 100 })] }));
}
export function withLoadingIndicator(Component) {
    return function EnhancedComponent(_a) {
        var isLoading = _a.isLoading, message = _a.message, props = __rest(_a, ["isLoading", "message"]);
        if (!isLoading) {
            return _jsx(Component, __assign({}, props));
        }
        return _jsx(Loading, { message: message });
    };
}
export default (Loading);
